import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigurationService } from '../../../configuration/app-configuration.service';
import { ApiSimpleListResponse } from '../../../webapi/models/response.model';
import { DictionaryMode } from '../../dictionary-mode.enum';
import { DictionaryType } from '../../dictionary-type.enum';
import { DictionaryServiceBase } from '../common/dictionary-service-base';
import { IAgrofagTypeDictionaryModel } from './agrofag-type-dictionary.model';

@Injectable()
export class AgrofagTypeDictionaryService extends DictionaryServiceBase<IAgrofagTypeDictionaryModel[]> {
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigurationService
  ) {
    super();
  }

  type: DictionaryType = DictionaryType.Agrofag;
  mode: DictionaryMode = DictionaryMode.Static;

  loadData(): Observable<IAgrofagTypeDictionaryModel[]> {
    const url = `${this.config.configuration.api_url}/api/farmdata/v1/dictionaries/Pesticide/agrofags`;

    return this.httpClient.get<ApiSimpleListResponse<string>>(url).pipe(
      map(result =>
        result.items.map(x => {
          return {
            agrofag: x,
            dictionaryType: DictionaryType[DictionaryType.Agrofag],
            codeName: x
          } as IAgrofagTypeDictionaryModel;
        })
      )
    );
  }
}
